function equalCardHeight(selector) {
    const cards = document.querySelectorAll(selector);

    if (!cards.length) return;

    let maxHeight = 0;

    cards.forEach(card => {
        card.style.height = "auto";
        maxHeight = Math.max(maxHeight, card.clientHeight);
    });

    cards.forEach(card => {
        card.style.height = `${maxHeight}px`;
    });
}

    equalCardHeight("#mainCollectionProductContainer .card__content");
    equalCardHeight(".tab-section-wrap .card__content");
    equalCardHeight(".shop-concern-wrapper .card__content");



document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".category-tab");
  const products = document.querySelectorAll(".card-product-item");

  // tabs.forEach(tab => {
  //   tab.addEventListener("click", function(e) {

  //     e.preventDefault();

  //     tabs.forEach(t => t.classList.remove("active"));
  //     this.classList.add("active");

  //     const selectedTag = this.dataset.tags;
  //     products.forEach(product => {
  //       const tags = product.dataset.tags
  //         .toLowerCase()
  //         .split(",")
  //         .map(tag => tag.trim());
  //       if (selectedTag === "all-products") {
  //           product.style.display = "block";
  //         } else if (tags.includes(selectedTag)) {
  //           product.style.display = "block";
  //         } else {
  //           product.style.display = "none";
  //         }
  //     });
  //   });
  // });



  const video = document.querySelector(".timeline-video");
  const section = document.querySelector(".section-results-timeline");

    if (video && section) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, {
        threshold: 0.5
      });

      observer.observe(section);
    }

  });


    // ==============================
    // PDP: clicking the rating badge scrolls to the review section
    // ==============================
    document.addEventListener("click", (e) => {
        const badge = e.target.closest(".jdgm-preview-badge, .jdgm-prev-badge, .custom_rating, .main-product ecx-product-rating");
        if (!badge) return;
        if (badge.closest(".rating-pdp-link")) return; // card/hero ratings navigate to the PDP instead
        if (badge.closest(".product-card")) return;    // card ratings handled below
        const widget = document.querySelector(".jdgm-review-widget, .jdgm-rev-widg");
        if (!widget) return;
        e.preventDefault();
        var targetY = widget.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: targetY, behavior: "smooth" });
        setTimeout(function () {
            if (Math.abs(window.pageYOffset - targetY) > 300) window.scrollTo(0, targetY);
        }, 700);
    });

    // ==============================
    // Product cards: clicking the rating opens the PDP
    // ==============================
    document.addEventListener("click", (e) => {
        const rating = e.target.closest(".product-card ecx-product-rating, .product-card .rating-wrapper");
        if (!rating) return;
        const card = rating.closest(".product-card");
        const titleLink = card && card.querySelector(".card__heading a");
        if (titleLink && titleLink.getAttribute("href")) {
            window.location.assign(titleLink.href);
        }
    });

    // ==============================
    // Card price update on variant change
    // ==============================
    const updateCardPrice = (productCard, ds) => {
        if (!ds || !ds.price) return;
        const priceEl = productCard.querySelector(".price");
        if (!priceEl) return;

        const hasCompare = !!(ds.comparePrice && ds.comparePrice.trim());

        const regularBlock = priceEl.querySelector(".price__regular");
        const saleBlock = priceEl.querySelector(".price__sale");
        const regularItem = priceEl.querySelector(".price__regular .price-item");
        const saleItem = priceEl.querySelector(".price__sale .price-item--last");
        const compareItem = priceEl.querySelector(".price__sale s");
        const discountEl = priceEl.querySelector(".discount-percentage");

        if (regularItem) regularItem.textContent = ds.price;
        if (saleItem) saleItem.textContent = ds.price;
        if (compareItem && hasCompare) compareItem.textContent = ds.comparePrice;

        if (regularBlock && saleBlock) {
            regularBlock.classList.toggle("d-none", hasCompare);
            regularBlock.classList.toggle("d-block", !hasCompare);
            saleBlock.classList.toggle("d-none", !hasCompare);
            saleBlock.classList.toggle("d-flex", hasCompare);
            if (hasCompare) saleBlock.classList.add("middle-xs", "fw-wrap");
        }

        if (discountEl) {
            if (hasCompare && ds.discount) {
                discountEl.textContent = ds.discount + "% Off";
                discountEl.style.display = "";
            } else {
                discountEl.style.display = "none";
            }
        }
    };

    // ==============================
    // Variant Dropdown
    // ==============================
    document.addEventListener("change", (e) => {
        const select = e.target.closest(".custom-variant-selects");
        if (!select) return;

        const productCard = select.closest(".product-card");
        if (!productCard) return;

        const selectedOption = select.selectedOptions[0];

        const image = productCard.querySelector(".img-first");
        const atcButton = productCard.querySelector(".js-custom-atc");

        if (atcButton) {
            atcButton.dataset.variantId = selectedOption.value;
        }

        if (image && selectedOption.dataset.image) {
            image.src = selectedOption.dataset.image;
            image.srcset = selectedOption.dataset.image;
        }

        updateCardPrice(productCard, selectedOption.dataset);
    });

    // ==============================
    // Variant Buttons
    // ==============================
    document.addEventListener("click", (e) => {
        const variantBtn = e.target.closest(".variant-btn");
        if (!variantBtn) return;

        const productCard = variantBtn.closest(".product-card");
        if (!productCard) return;

        const image = productCard.querySelector(".img-first");
        const atcButton = productCard.querySelector(".js-custom-atc");

        if (atcButton) {
            atcButton.dataset.variantId = variantBtn.dataset.variantId;
        }

        if (image && variantBtn.dataset.image) {
            image.src = variantBtn.dataset.image;
            image.srcset = variantBtn.dataset.image;
        }

        // Active Class
        productCard.querySelectorAll(".variant-btn").forEach(btn => {
            btn.classList.remove("active");
        });

        variantBtn.classList.add("active");

        updateCardPrice(productCard, variantBtn.dataset);
    });

    // ==============================
    // Add To Cart
    // ==============================


  document.addEventListener("click", async (e) => {

    const btn = e.target.closest(".js-custom-atc");
    if (!btn) return;

    const variantId = btn.dataset.variantId;

    if (!variantId) {
        console.error("Variant ID not found");
        return;
    }

    const card = btn.closest(".product-card");

    const personalizationInput = card?.querySelector(".personalization-input");
    const personalization = personalizationInput?.value.trim() || "";

    const PERSONALIZATION_VARIANT_ID = 40692874707151;

    const items = [];

    // Main Product
    const mainProduct = {
        id: Number(variantId),
        quantity: 1
    };

    if (personalization) {
        mainProduct.properties = {
            Personalization: personalization
        };
    }



    if (personalization) {
        items.push({
            id: 40692874707151,
            quantity: 1
        });
    }
    items.push(mainProduct);
    try {

        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                items: items
            }),
        });

         const data = await response.json();

        console.log("Items Sent:", items);
        console.log("Response:", data);

        if (!response.ok) {
            throw new Error(data.description || data.message);
            console.log(data);
        }



        console.log("Added:", data);

        if (typeof updateCartCount === "function") {
            await updateCartCount();
        }

        if (window.ECXHelper?.forceUpdateCartStatus) {
            window.ECXHelper.forceUpdateCartStatus();
        }

        document.documentElement.dispatchEvent(
            new CustomEvent("cart:update")
        );

        setTimeout(() => {
            const headerCartBtn = document.querySelector(".js-header-cart-status-btn");

            if (headerCartBtn && window.ecxCartDrawer) {
                window.ecxCartDrawer.openDrawer(headerCartBtn);
            }
        }, 80);

    } catch (err) {
        console.error(err);
    }

});


    // free gift start

    window.freeGift = async function () {
      if (!window.freeGiftSettings) return;

      // Single-flight: freeGift is triggered from several places (add-to-cart
      // toggle, variant render, cart notification, and the drawer form's
      // constructor on every drawer re-render), so calls overlap. Two
      // concurrent runs each see "no gift yet" and both add one (stacked
      // freebies), and a run started before the cart was emptied re-adds a
      // stale gift afterwards. Let one run fly; extra triggers just request
      // one trailing re-run, which then operates on fresh cart data and
      // self-corrects anything that changed mid-flight.
      if (window.__freeGiftBusy) {
        window.__freeGiftRerun = true;
        return;
      }
      window.__freeGiftBusy = true;

      const checkoutBtn =
      document.querySelector('button[name="checkout"]');

      if (checkoutBtn) {
        checkoutBtn.disabled = true;
        checkoutBtn.style.pointerEvents = "none";
      }

      try {
        const settings = window.freeGiftSettings;
        const cart = await fetch("/cart.js").then(res => res.json());

        const subtotal = cart.items_subtotal_price / 100;

        const slabs = [
          settings.slab1,
          settings.slab2,
          settings.slab3
        ];

        console.log("Cart Subtotal:", subtotal);

        for (const slab of slabs) {
          if (!slab || !slab.variantId) continue;

          const variantId = Number(slab.variantId);
          const threshold = Number(slab.threshold);

          const gift = cart.items.find(item =>
            Number(item.variant_id) === variantId &&
            item.properties &&
            item.properties.freeGift
          );

          const eligible = subtotal >= threshold;

          console.log("----------------");
          console.log("Variant:", variantId);
          console.log("Threshold:", threshold);
          console.log("Eligible:", eligible);
          console.log("Gift Exists:", !!gift);

          // Add Gift
          if (eligible && !gift) {
            const res = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: 1,
                    properties: {
                      freeGift: "true"
                    }
                  }
                ]
              })
            });

            if (res.ok) {
              document.documentElement.dispatchEvent(
                new CustomEvent("cart:update", {
                  bubbles: true
                })
              );
            }
          }

          // Normalize a stacked gift (races before the single-flight lock
          // could leave quantity > 1) back down to exactly one.
          if (eligible && gift && gift.quantity !== 1) {
            const res = await fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                id: gift.key,
                quantity: 1
              })
            });

            if (res.ok) {
              document.documentElement.dispatchEvent(
                new CustomEvent("cart:update", {
                  bubbles: true
                })
              );
            }
          }

          // Remove Gift
          if (!eligible && gift) {
              const res = await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  id: gift.key,
                  quantity: 0
                })
              });

              if (res.ok) {
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:update", {
                    bubbles: true
                  })
                );
              }
          }
        }
      } catch (err) {
        console.error("Free Gift Error:", err);
      } finally {
        // Re-enable checkout the moment the gift sync finishes. The old
        // 4-second minimum lock left mobile shoppers tapping a dead button.
        const checkout_btn =
          document.querySelector('button[name="checkout"]');

        if (checkout_btn) {
          checkout_btn.disabled = false;
          checkout_btn.style.pointerEvents = "";
        }

        window.__freeGiftBusy = false;
        if (window.__freeGiftRerun) {
          window.__freeGiftRerun = false;
          window.freeGift();
        }
      }
    };

    // end

    async function updateCartCount() {
      const cart = await fetch("/cart.js").then(res => res.json());

      document.querySelectorAll(".cart-count-number").forEach(el => {
          el.textContent = cart.item_count;
          document.querySelector('.js-cart-drawer-wrapper .drawer__heading').innerHTML = `Your Cart (${cart.item_count})`;
      });

      document.querySelectorAll(".header__cart-count").forEach(el => {
          el.style.display = cart.item_count > 0 ? "" : "none";
      });

      document.querySelectorAll(".visually-hidden").forEach(el => {
          if (el.textContent.includes("items")) {
              el.textContent = `${cart.item_count} items`;
          }
      });
    }

    // for only-one freebies add on cart

    async function canAddFreebie() {
      const cart = await fetch('/cart.js').then(res => res.json());

      const hasFreebie = cart.items.some(item => {
        console.log("Item:", item);
        console.log("Properties:", item.properties);

        return item.properties && item.properties.freeGift === "true";
      });

      console.log("Cart:", cart);
      console.log("Has Freebie:", hasFreebie);

      return !hasFreebie;
    }



  function checkVariantAndModifyCart(variantIdToCheck) {
    const cartURL = '/cart.js';

    fetch(cartURL)
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(cartData => {
            let variantExists = cartData.items.some(item => item.variant_id === parseInt(variantIdToCheck));
                return fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: variantIdToCheck,
                        quantity: 0
                    })
                });

        })
        .then(() => fetch(cartURL))
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(cartData => {
            let items = cartData.items;
            let jsonObj = [];

            items.forEach(item => {
                let properties = item.properties;
                if (item.variant_id !== parseInt(variantIdToCheck)) {
                    if (properties && properties.Personalization) {
                        jsonObj.push({
                            id: parseInt(variantIdToCheck),
                            quantity: 1,
                            properties: { Personalization: properties.Personalization }
                        });
                    }
                    if (properties && properties['Personalization 2']) {
                        jsonObj.push({
                            id: parseInt(variantIdToCheck),
                            quantity: 1,
                            properties: { 'Personalization 2': properties['Personalization 2'] }
                        });
                    }
                }
            });

            if (jsonObj.length > 0) {
                return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ items: jsonObj })
                });
            } else {
                return Promise.resolve();
            }
        })
        .then(() => {
          console.log("persona")
           document.documentElement.dispatchEvent(
                new CustomEvent("cart:update", {
                  bubbles: true
                })
              );
        })
        .catch(error => {
            console.error('Error:', error);
        });
}

// window.checkVariantAndModifyCart = async function (customizationVariantId) {
//   const originalInput = document.getElementById("your-name-new");
//   try {
//     const cart = await fetch("/cart.js").then(res => res.json());

//     const items = [];

//     cart.items.forEach(item => {
//       if (item.properties?.Personalization) {
//         items.push({
//           id: 40692874707151,
//           quantity: 1,
//           properties: {
//             Customization: originalInput.value
//           }
//         });
//       }
//     });

//     console.log("Items to add:", items);

//     if (!items.length) return;

//     const response = await fetch("/cart/add.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({ items })
//     });

//     console.log(await response.json());

//     document.documentElement.dispatchEvent(
//       new CustomEvent("cart:update", {
//         bubbles: true
//       })
//     );

//   } catch (error) {
//     console.error(error);
//   }
// };

// ==============================
// Tab strips (Shop by Concern / Oral Care Essentials): auto-scroll the bar so
// the tapped chip centers and the next chips peek into view
// ==============================
document.addEventListener("click", (e) => {
    const chip = e.target.closest(".shop-concern-mobile .collection-tab, .tab__header .tab__link, .category-tabs .category-tab");
    if (!chip) return;
    // find the horizontal scroller this chip lives in
    let scroller = chip.parentElement;
    while (scroller && scroller !== document.body) {
        const cs = getComputedStyle(scroller);
        if ((cs.overflowX === "auto" || cs.overflowX === "scroll") && scroller.scrollWidth > scroller.clientWidth) break;
        scroller = scroller.parentElement;
    }
    if (!scroller || scroller === document.body) return;
    // wait for the tab's own handlers to finish, then center the chip
    setTimeout(() => {
        const cRect = chip.getBoundingClientRect();
        const sRect = scroller.getBoundingClientRect();
        const target = scroller.scrollLeft + (cRect.left - sRect.left) - (scroller.clientWidth - cRect.width) / 2;
        scroller.scrollTo({ left: Math.max(0, target), behavior: "smooth" });
    }, 150);
});

// On load: center the active collection chip so users see where they are and what's next
(function () {
    function centerActiveChip() {
        const active = document.querySelector(".category-tabs .category-tab.active");
        if (!active) return;
        const scroller = active.closest(".category-tabs");
        if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;
        const cRect = active.getBoundingClientRect();
        const sRect = scroller.getBoundingClientRect();
        const target = scroller.scrollLeft + (cRect.left - sRect.left) - (scroller.clientWidth - cRect.width) / 2;
        scroller.scrollTo({ left: Math.max(0, target), behavior: "smooth" });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => setTimeout(centerActiveChip, 300));
    } else {
        setTimeout(centerActiveChip, 300);
    }
})();

// ==============================
// PDP price box: live-update when a variant is picked (non-pack-size products)
// ==============================
document.addEventListener("change", (e) => {
    const radio = e.target.closest(".js-variant-picker input.js-variant-radio-item, .js-variant-picker select");
    if (!radio) return;
    const picker = radio.closest(".js-variant-picker");
    const box = picker && picker.querySelector(".single-variant-price");
    const dataEl = picker && picker.querySelector(".js-svp-variants");
    if (!box || !dataEl) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    // collect the currently selected option values in option order
    const selected = [];
    picker.querySelectorAll("fieldset.js-variant-radio-container").forEach((fs) => {
        const checked = fs.querySelector("input.js-variant-radio-item:checked");
        if (checked) selected.push(checked.value);
    });
    if (!selected.length) return;
    const match = variants.find((v) => selected.every((val, i) => v.options[i] === val));
    if (!match) return;
    const money = (cents) => "₹" + (Math.round(cents / 100)).toLocaleString("en-IN");
    const priceEl = box.querySelector(".main-price");
    const cmpEl = box.querySelector(".cmprice");
    const saveEl = box.querySelector(".inner-save");
    const coinsEl = box.querySelector(".perfcoins");
    if (priceEl) priceEl.textContent = money(match.price);
    if (match.compare_at_price && match.compare_at_price > match.price) {
        if (cmpEl) cmpEl.textContent = money(match.compare_at_price);
        if (saveEl) saveEl.textContent = "Save " + money(match.compare_at_price - match.price);
        if (cmpEl) cmpEl.style.display = "";
        if (saveEl) saveEl.style.display = "";
    } else {
        if (cmpEl) cmpEl.style.display = "none";
        if (saveEl) saveEl.style.display = "none";
    }
    if (coinsEl) {
        const coinsNum = Math.round((match.price / 100) * 0.1 / 5) * 5;
        coinsEl.textContent = coinsNum > 0 ? "Get " + coinsNum + " PerfCoins" : "";
    }
});

// ==============================
// Search bar typing animation (desktop input placeholder + mobile pill text)
// ==============================
(function () {
    const KEYWORDS = ["Teeth Whitening", "Flosser", "Plaque"];
    const TYPE_MS = 95, DELETE_MS = 45, HOLD_MS = 1500, GAP_MS = 350;

    function init() {
        if (!document.querySelector("input#st-search") && !document.querySelector(".header__mobile-search-text")) return;

        let ki = 0, ci = 0, deleting = false;

        function apply(showCursor) {
            const word = KEYWORDS[ki].slice(0, ci);
            const text = "Search “" + word + (showCursor ? "|" : "") + "”";
            // query fresh each time — SearchTap can re-mount its input after load
            document.querySelectorAll("input#st-search").forEach(function (i) {
                if (document.activeElement !== i) i.setAttribute("placeholder", text);
            });
            document.querySelectorAll(".header__mobile-search-text").forEach(function (p) { p.textContent = text; });
        }

        function tick() {
            const word = KEYWORDS[ki];
            if (!deleting) {
                ci++;
                apply(true);
                if (ci >= word.length) {
                    deleting = true;
                    apply(false);
                    setTimeout(tick, HOLD_MS);
                    return;
                }
                setTimeout(tick, TYPE_MS);
            } else {
                ci--;
                apply(true);
                if (ci <= 0) {
                    deleting = false;
                    ki = (ki + 1) % KEYWORDS.length;
                    setTimeout(tick, GAP_MS);
                    return;
                }
                setTimeout(tick, DELETE_MS);
            }
        }

        tick();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();

// cache-bump 2026-08-11

// ==============================
// Return & Exchange page: CTA buttons below the policy pointers
// ==============================
(function () {
    function initReturnCtas() {
        var grid = document.querySelector('.return-sec-wrap .text-sec-outer.grid-4-col');
        if (!grid) return;
        if (document.querySelector('.rx-cta-row')) return;
        // page body may already carry these buttons (original page) - don't duplicate
        var existing = [].slice.call(document.querySelectorAll('a')).some(function (a) {
            return /perfora support/i.test(a.textContent || '');
        });
        if (existing) return;
        var row = document.createElement('div');
        row.className = 'rx-cta-row';
        row.innerHTML =
            '<a class="rx-btn rx-btn--black" href="https://perforacare.clickpost.in/en/returns" target="_blank" rel="noopener">Place your Return/Exchange</a>' +
            '<a class="rx-btn rx-btn--wa" href="https://wa.me/919999289288" target="_blank" rel="noopener">' +
            '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M12.04 2c-5.46 0-9.9 4.43-9.9 9.88 0 1.74.46 3.44 1.32 4.94L2 22l5.32-1.4c1.45.8 3.08 1.21 4.72 1.21h.01c5.46 0 9.9-4.43 9.9-9.88 0-2.64-1.03-5.12-2.9-6.99A9.85 9.85 0 0 0 12.04 2m0 1.67c2.2 0 4.26.85 5.82 2.4a8.16 8.16 0 0 1 2.41 5.83c0 4.54-3.7 8.22-8.24 8.22-1.48 0-2.93-.4-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c.01-4.54 3.71-8.21 8.25-8.21m4.52 10.13c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.17.24-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.1-.23-.16-.48-.29"/></svg>' +
            '<span>Perfora Support</span></a>';
        grid.insertAdjacentElement('afterend', row);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initReturnCtas);
    } else {
        initReturnCtas();
    }
})();

// ==============================
// Announcement bar: wrap the star emoji so it can be sized independently of the text
// ==============================
(function () {
    var STAR = /⭐️?/g;
    function wrapStars(root) {
        var items = (root || document).querySelectorAll(".anmb .js-anmb-item a, .anmb .js-anmb-item > span");
        Array.prototype.forEach.call(items, function (el) {
            if (el.dataset.starsWrapped === "1") return;
            if (!STAR.test(el.textContent)) { el.dataset.starsWrapped = "1"; return; }
            STAR.lastIndex = 0;
            el.innerHTML = el.innerHTML.replace(STAR, '<span class="anmb-star">⭐</span>');
            el.dataset.starsWrapped = "1";
        });
    }
    function init() {
        wrapStars();
        var bar = document.querySelector(".anmb");
        if (!bar || !window.MutationObserver) return;
        var mo = new MutationObserver(function () { wrapStars(bar); });
        mo.observe(bar, { childList: true, subtree: true });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();

// ==============================
// Cart drawer: wrap the savings text so it can shimmer (emoji stays outside the gradient)
// ==============================
(function () {
    function wrapSavings() {
        var bars = document.querySelectorAll(".cart-total-savings-bar");
        Array.prototype.forEach.call(bars, function (bar) {
            if (bar.querySelector(".save-shimmer")) return;
            var raw = bar.textContent.trim();
            if (!raw) return;
            var m = raw.match(/^(\s*[^\w₹]*\s*)?(.*)$/);
            var lead = (m && m[1]) ? m[1].trim() : "";
            var rest = (m && m[2]) ? m[2].trim() : raw;
            bar.innerHTML = (lead ? lead + " " : "") + '<span class="save-shimmer"></span>';
            bar.querySelector(".save-shimmer").textContent = rest;
        });
    }
    function init() {
        wrapSavings();
        var drawer = document.getElementById("ecxCartDrawer");
        if (!drawer || !window.MutationObserver) return;
        var pending = false;
        var mo = new MutationObserver(function () {
            if (pending) return;
            pending = true;
            requestAnimationFrame(function () { pending = false; wrapSavings(); });
        });
        mo.observe(drawer, { childList: true, subtree: true });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();

// ==============================
// PDP: sticky Add to Cart bar (mobile + desktop)
// Mirrors the page's own controls - the dropdown drives the real variant picker
// and the button clicks the real ATC, so cart/personalisation logic is untouched.
// ==============================
(function () {
    var bar, sel, priceEl, cmpEl, btn;

    function realAtc() {
        return document.querySelector(".product-details .js-product-form-submit-btn, .main-product .js-product-form-submit-btn");
    }
    function picker() {
        return document.querySelector(".product-details .js-variant-picker, .main-product .js-variant-picker");
    }
    function optionGroups() {
        var p = picker();
        if (!p) return [];
        var groups = [];
        p.querySelectorAll("fieldset.js-variant-radio-container").forEach(function (fs) {
            var inputs = [].slice.call(fs.querySelectorAll("input.js-variant-radio-item"));
            if (inputs.length > 1) groups.push({ name: (fs.querySelector(".product-option__name span") || {}).textContent || "Option", inputs: inputs });
        });
        return groups;
    }
    function currentPrice() {
        var p = picker();
        if (!p) return null;
        var checked = p.querySelector("li.js-variant-option-value input:checked");
        var li = checked && checked.closest("li.js-variant-option-value");
        if (li && li.querySelector(".main-price")) {
            return { price: li.querySelector(".main-price").textContent.trim(), compare: (li.querySelector(".cmprice") || {}).textContent };
        }
        var box = p.querySelector(".single-variant-price");
        if (box && box.querySelector(".main-price")) {
            return { price: box.querySelector(".main-price").textContent.trim(), compare: (box.querySelector(".cmprice") || {}).textContent };
        }
        var generic = document.querySelector(".product-details .price .price-item--last, .product-details .price .price-item");
        return generic ? { price: generic.textContent.trim(), compare: "" } : null;
    }
    function syncPrice() {
        var cur = currentPrice();
        if (!cur || !priceEl) return;
        priceEl.textContent = cur.price || "";
        var c = (cur.compare || "").trim();
        cmpEl.textContent = c;
        cmpEl.style.display = c ? "" : "none";
    }
    function syncSelect() {
        if (!sel) return;
        var groups = optionGroups();
        if (!groups.length) return;
        var checked = groups[0].inputs.filter(function (i) { return i.checked; })[0];
        if (checked) sel.value = checked.value;
    }
    function build() {
        var atc = realAtc();
        if (!atc || document.querySelector(".pf-sticky-atc")) return;

        bar = document.createElement("div");
        bar.className = "pf-sticky-atc";

        var left = document.createElement("div");
        left.className = "pf-sticky-atc__left";

        var groups = optionGroups();
        if (groups.length) {
            sel = document.createElement("select");
            sel.className = "pf-sticky-atc__select";
            sel.setAttribute("aria-label", "Select " + groups[0].name.trim());
            groups[0].inputs.forEach(function (input) {
                var li = input.closest("li.js-variant-option-value, .product-swatches__item");
                var o = document.createElement("option");
                o.value = input.value;
                o.textContent = input.value + (li && li.classList.contains("product-option--unavailable") ? " — Out of stock" : "");
                if (li && li.classList.contains("product-option--unavailable")) o.disabled = true;
                if (input.checked) o.selected = true;
                sel.appendChild(o);
            });
            sel.addEventListener("change", function () {
                var target = groups[0].inputs.filter(function (i) { return i.value === sel.value; })[0];
                if (!target) return;
                var label = target.closest("li, .product-swatches__item");
                var clickable = (label && label.querySelector("label")) || target;
                clickable.click();
                setTimeout(syncPrice, 120);
            });
            left.appendChild(sel);
        }

        var priceWrap = document.createElement("div");
        priceWrap.className = "pf-sticky-atc__price";
        priceEl = document.createElement("span");
        priceEl.className = "pf-sticky-atc__now";
        cmpEl = document.createElement("s");
        cmpEl.className = "pf-sticky-atc__was";
        priceWrap.appendChild(priceEl);
        priceWrap.appendChild(cmpEl);
        left.appendChild(priceWrap);

        btn = document.createElement("button");
        btn.type = "button";
        btn.className = "pf-sticky-atc__btn";
        btn.textContent = "Add to Cart";
        btn.addEventListener("click", function () {
            var a = realAtc();
            if (a) a.click();
        });

        bar.appendChild(left);
        bar.appendChild(btn);
        document.body.appendChild(bar);

        syncPrice();
        document.addEventListener("change", function (e) {
            if (e.target.closest && e.target.closest(".js-variant-picker")) { syncPrice(); syncSelect(); }
        });
        document.addEventListener("click", function (e) {
            if (e.target.closest && e.target.closest(".js-variant-picker")) setTimeout(function () { syncPrice(); syncSelect(); }, 150);
        });
    }

    function threshold() {
        if (window.innerWidth <= 768) return window.innerHeight * 1.5;
        var media = document.querySelector(".product-details .js-product-media-wrapper, .product-details .product__media-wrapper");
        if (!media) return window.innerHeight;
        var r = media.getBoundingClientRect();
        return r.bottom + window.pageYOffset - 80;
    }
    function onScroll() {
        if (!bar) return;
        bar.classList.toggle("is-visible", window.pageYOffset > threshold());
    }

    function init() {
        if (!realAtc()) return;
        build();
        onScroll();
        var ticking = false;
        window.addEventListener("scroll", function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () { ticking = false; onScroll(); });
        }, { passive: true });
        window.addEventListener("resize", onScroll, { passive: true });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();

// ==============================
// PDP: the whole pack box selects that variant (not just the coloured label)
// ==============================
document.addEventListener("click", function (e) {
    var li = e.target.closest && e.target.closest(".js-variant-picker li.js-variant-option-value");
    if (!li) return;
    if (e.target.closest("label") || e.target.tagName === "INPUT") return; // native behaviour handles these
    var input = li.querySelector("input.js-variant-radio-item");
    if (!input || input.disabled || input.checked) return;
    var label = li.querySelector("label.js-variant-option-label") || li.querySelector("label");
    (label || input).click();
});
